const parseEventStart = (dateStr, timeStr) => {
  if (!dateStr && !timeStr) return null;

  // If `time` is a full ISO datetime, just use it.
  if (timeStr) {
    const dt = new Date(timeStr);
    if (!isNaN(dt)) return dt;
  }

  // Fallback: build from date only (treat as UTC midnight to avoid TZ drift)
  const m = /^(\d{4})[-/](\d{2})[-/](\d{2})/.exec(dateStr || '');
  if (m) {
    const [, Y, M, D] = m.map(Number);
    return new Date(Date.UTC(Y, M, D));
  }

  const d = new Date(dateStr);
  return isNaN(d) ? null : d;
};

export default parseEventStart;
